import { createSlice } from '@reduxjs/toolkit';

import { errorPopupToggled } from '../../actions/priceMatrixActions';

// Merges into the existing error, as combo-summary's does and transfer-list's does not.
const errorSlice = createSlice({
  name: 'error',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(errorPopupToggled, (state, action) => ({ ...state, ...action.payload }));
  },
});

export default errorSlice.reducer;
